import { useEffect } from 'react';
import { screenSizeSubject } from './screenSizeObserverRxjs';
import { useAppDispatch } from 'src/app/hooks';
import { setScreenSizeAndIsMobile } from 'src/features/ui/uiSlice';

export default function ScreenSizeObserver() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const subscription = screenSizeSubject.subscribe((size) => {
      dispatch(setScreenSizeAndIsMobile(size));
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);
  return null;
}
